import { Grid } from '@mui/material';
import crsAcls from 'src/careflow/ph-core/admin/permissions/util/crs/crsAcls';
import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import { WrappedPatient } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient';
import ExpandableCard from 'src/components/common/ExpandableCard';
import PatientGenericCarePlan from '../../patient/care-plan/PatientGenericCarePlan';
import PatientCase from '../../patient/cases/patientCase';
import { i18nFunction } from 'src/careflow/ph-core/internationalization/hook/useLocales';

function Cases({
  encounter,
  patient,
  i18n,
}: {
  encounter?: string;
  patient?: WrappedPatient | null;
  i18n: i18nFunction;
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {checkAclValidation({ acls: [crsAcls.CRS.EPISODE_OF_CARE.CASES.CASES.VIEW] })}
        <ExpandableCard
          title={i18n('episodeOfCare.details.cases.titleCase', 'crs')}
          sxProp={{ m: 1 }}
          openCollapseExternal={true}
        >
          <PatientCase
            patientId={encounter ? patient?.id : undefined}
            encounterId={encounter}
            title={i18n('episodeOfCare.details.cases.titleCase', 'crs')}
            i18n={i18n}
            disableActions={true}
          />
        </ExpandableCard>

        {checkAclValidation({
          acls: [crsAcls.CRS.EPISODE_OF_CARE.CASES.CARE_PLAN.VIEW],
        }) ? (
          <ExpandableCard
            title={i18n('episodeOfCare.details.cases.titleCarePlan', 'crs')}
            sxProp={{ m: 1 }}
            openCollapseExternal={true}
          >
            <PatientGenericCarePlan
              patientId={encounter ? patient?.id : undefined}
              encounter={encounter}
              i18n={i18n}
            />
          </ExpandableCard>
        ) : null}
      </Grid>
    </Grid>
  );
}

export default Cases;
